import { SellerIndependentPageHeader } from 'sellDirect/components/offer/SellerHeader';
import { Layout } from 'platform/components/layout/Layout';
import { ORVASchedule } from 'sellDirect/components/homeWalkthrough/ORVASchedule';
import { useOfferContext, VAInProgressOffer, SentOffer } from 'sellDirect/OfferContext';
import { isOpendoorAppEvoWebView } from 'shared/helpers/globals';
import {
  getHubSellingRoute,
  getHubOverviewRoute,
  getHubSSVAUploadRoute,
  getHubVirtualAssessmentQuestionsRoute,
} from 'shared/helpers/routes';
import React, { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { Redirect } from 'platform/react-router';
import { VALayout } from 'sellDirect/components/va/VALayout';
import { useHistory } from 'platform/HistoryProvider';
import { OdProtosWebData_ORVAState as ORVAState } from '__generated__/globalTypes';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

/** Page where customers can schedule an ORVA */
export const SchedulePage: React.FC<{ offer: SentOffer | VAInProgressOffer }> = ({ offer }) => {
  const {
    shouldSeeAgentExperience,
    experimentationData: { shouldSeeVAQuestionPage, shouldSeeSsvaNooExperience },
  } = useOfferContext();
  const { addressUUID } = useQualificationContext();

  const { isRoutePresent } = useHistory();

  const {
    orvaData: { orvaState, loadingCalendlyAvailability },
    isExpired,
  } = offer;

  const shouldNotSeeSchedulePage = useMemo(
    () => orvaState === ORVAState.ORVA_SCHEDULED || isExpired,
    [isExpired, orvaState],
  );

  if (shouldNotSeeSchedulePage) {
    if (isOpendoorAppEvoWebView) {
      if (isRoutePresent(getHubOverviewRoute())) {
        return <Redirect to={generatePath(getHubOverviewRoute(), { addressUUID })} />;
      }
      return <Redirect to={generatePath(getHubSellingRoute(), { addressUUID })} />;
    }

    return <Redirect to={generatePath(getHubOverviewRoute(), { addressUUID })} />;
  }

  if (shouldSeeAgentExperience) {
    return <Redirect to={generatePath(getHubSSVAUploadRoute(), { addressUUID })} />;
  }

  if (shouldSeeVAQuestionPage) {
    /**
     * Redirect to the question page if the user is in treatment,
     * has not started a VA
     * and has not answered the Occupancy question
     */
    return (
      <Redirect
        to={generatePath(getHubVirtualAssessmentQuestionsRoute(), {
          addressUUID,
        })}
      />
    );
  }
  return (
    <Layout
      hideNav
      renderHeader={() => <SellerIndependentPageHeader title="Show us your home" />}
      hideFooter
      isLoading={loadingCalendlyAvailability}
    >
      <VALayout vaExperience="orva" hideSwitchCard={!shouldSeeSsvaNooExperience}>
        <ORVASchedule orvaData={offer.orvaData} />
      </VALayout>
    </Layout>
  );
};
